(() => {
  const initWalltraudMagnetboardLandingpage = () => {
    const page = document.querySelector('[data-wt-magnetboard-page]');

    if (!page) return;

    const heroButton = page.querySelector(
      '[data-wt-magnetboard-hero-cta]'
    );

    const product = document.querySelector(
      '[data-wt-magnetboard-product]'
    );

    const sticky = page.querySelector(
      '[data-wt-magnetboard-sticky]'
    );

    if (
      sticky &&
      sticky.dataset.wtMagnetboardInitialized !== 'true'
    ) {
      sticky.dataset.wtMagnetboardInitialized = 'true';

      if (
        heroButton &&
        product &&
        'IntersectionObserver' in window
      ) {
        let heroVisible = true;
        let productVisible = false;

        const updateSticky = () => {
          const show = !heroVisible && !productVisible;

          sticky.classList.toggle(
            'is-visible',
            show
          );

          sticky.setAttribute(
            'aria-hidden',
            show ? 'false' : 'true'
          );
        };

        const heroObserver = new IntersectionObserver(
          (entries) => {
            heroVisible = entries[0].isIntersecting;
            updateSticky();
          },
          {
            threshold: 0
          }
        );

        const productObserver = new IntersectionObserver(
          (entries) => {
            productVisible = entries[0].isIntersecting;
            updateSticky();
          },
          {
            threshold: 0.06
          }
        );

        heroObserver.observe(heroButton);
        productObserver.observe(product);
      }
    }

    document
      .querySelectorAll(
        '.wt-magnetboard-section a[href^="#"]'
      )
      .forEach((link) => {
        if (
          link.dataset.wtMagnetboardSmooth === 'true'
        ) {
          return;
        }

        link.dataset.wtMagnetboardSmooth = 'true';

        link.addEventListener(
          'click',
          (event) => {
            const selector =
              link.getAttribute('href');

            if (
              !selector ||
              selector === '#'
            ) {
              return;
            }

            const target =
              document.querySelector(selector);

            if (!target) return;

            event.preventDefault();

            target.scrollIntoView({
              behavior: window.matchMedia(
                '(prefers-reduced-motion: reduce)'
              ).matches
                ? 'auto'
                : 'smooth',
              block: 'start'
            });
          }
        );
      });
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initWalltraudMagnetboardLandingpage
    );
  } else {
    initWalltraudMagnetboardLandingpage();
  }

  document.addEventListener(
    'shopify:section:load',
    initWalltraudMagnetboardLandingpage
  );
})();